export default __webpack_public_path__ + "static/logo-3306b9af4544dd0e0404e6832008032b.png";